<template>
  <div class="c-sub-side-nav">
    <!-- <plv-breakpoint-div class="c-side-nav-title">
      <div class="c-side-nav-title__content">分账号详情</div>
    </plv-breakpoint-div> -->
    <plv-menu
      v-bind="childrenNavOptions"
      class="g-children-nav-bar"
      use-router-link
    >
      <plv-menu-group icon="home" title="分账号管理">
        <plv-menu-item
          :index="`/group/subAccount/${id}/detail`"
          title="账号信息"
        />
        <plv-menu-item
          :index="`/group/subAccount/${id}/priceSetting`"
          title="单价设置"
        />
        <plv-menu-item
          :index="`/group/subAccount/${id}/liveSetting`"
          title="云直播设置"
        />
        <plv-menu-item
          :index="`/group/subAccount/${id}/vodSetting`"
          title="云点播设置"
        />
        <plv-menu-item
          :index="`/group/subAccount/${id}/businessUsage`"
          title="业务用量"
        />
      </plv-menu-group>
    </plv-menu>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      childrenNavOptions: {
        background: '#F8F9FA',
        groupNormalFontColor: '#757575',
        normalFontColor: '#333333',
        hoverFontColor: '#2196f3',
        activeFontColor: '#2196f3',
        normalBackground: '#F8F9FA',
        hoverBackground: '#F8F9FA',
        activeBackground: 'rgba(33, 150, 243, 0.1)',
        forceOpen: true,
        grayScroll: true,
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.c-sub-side-nav {
  height: 100%;
  .c-side-nav-title {
    background: #F8F9FA;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
